//import '../css/top.scss';
import * as factoryScript from './_top_new.js';
//import layzyload from 'layzyload';


window.addEventListener('DOMContentLoaded', function(){
	factoryScript.init();
});


